import { connect } from "react-redux";
import CallLogging from "../components/CarerApp/CallLogging";
import { mapStateToProps, mapDispatchToProps } from "./CarerAppContainer";

export default connect(mapStateToProps, mapDispatchToProps)(CallLogging);
